var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountHead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-account",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes lightSpeedRight{60%{transform:skewX(10deg);opacity:1}80%{transform:skewX(-2deg)}}@keyframes slideRight{0%{opacity:0;transform:translateX(30px)}to{opacity:1;transform:translateX(0)}}@keyframes slideDown{0%{opacity:0;transform:translateY(-30px)}to{opacity:1;transform:translateY(0)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}svg#freepik_stories-account:not(.animated) .animable{opacity:0}")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6",
    style: {
      transformOrigin: "294.171px 241.224px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedRight",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "306.28px 243.345px 0"
    },
    id: "elkfvea8dgq9g",
    className: "animable",
    d: "M187.83 80.54h236.9v325.61h-236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "306.28px 89.39px 0"
    },
    id: "el72t8u4zer1a",
    className: "animable",
    d: "M187.83 80.54h236.9v17.7h-236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.57 89.39a2.38 2.38 0 1 1-2.38-2.39 2.38 2.38 0 0 1 2.38 2.39z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "196.19px 89.38px 0"
    },
    id: "ely0fy2azumfg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4 88.88a2.38 2.38 0 1 1-2.4-2.39 2.38 2.38 0 0 1 2.4 2.39z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "214.02px 88.8699px 0"
    },
    id: "el05ihpe7qmuo3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.92 88.88a2.38 2.38 0 1 1-2.38-2.39 2.38 2.38 0 0 1 2.38 2.39z",
    style: {
      fill: "#f5f5f5",
      transformOrigin: "205.54px 88.87px 0"
    },
    id: "elqy3x8kxixi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.23 114.31s-9.44-3.91-15.77 18.07-7.95 34.28-7.95 34.28-1.89 4.71-5.3 2.53-8.86-9.2-13.48-6.85c-4.8 2.43-5.38 8.42-2.8 16.56s7.58 26.18 8 27.81 0 4.18-2.59 3.07-18.37-13.09-23.6-5.24 5.68 29.33 6.83 31.71.86 3.53-.21 4.38-6-3.68-10.64-6.9-10.57-6.14-13.21-1.36-.44 22.06 21.17 46.65l10.77 10.74 14.8-3.73c31.2-9.91 42-23.57 42.22-29s-6.39-6-12-5.65-12.19 1.69-12.67.42-.12-2.42 2.09-3.86 22.65-14.22 22.21-23.64-20.15-7.32-22.92-7.69-1.84-2.82-.64-4 14.81-14.05 21.22-19.69 9-11.06 6.16-15.63c-2.75-4.39-11-1.2-15.08-1.09s-3.23-4.9-3.23-4.9 4.94-11.37 10.87-33.46-4.48-23.6-4.48-23.6",
    style: {
      fill: "#ebebeb",
      transformOrigin: "415.843px 201.9px 0"
    },
    id: "el0mb08af3sbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.53 134s0 .16-.1.47-.2.78-.34 1.36c-.32 1.23-.77 3-1.36 5.24-1.18 4.55-2.94 11.12-5.15 19.22-4.42 16.21-10.7 38.56-17.73 63.21s-13.37 47-17.87 63.17l-5.31 19.17c-.63 2.25-1.12 4-1.45 5.21-.17.58-.3 1-.39 1.36l-.15.45s0-.16.09-.47.2-.78.34-1.36c.32-1.22.78-3 1.36-5.24 1.18-4.55 2.95-11.11 5.16-19.22 4.41-16.21 10.7-38.55 17.72-63.21s13.37-47 17.87-63.17l5.32-19.19c.62-2.25 1.11-4 1.45-5.21q.24-.87.39-1.35c.09-.3.15-.44.15-.44z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "419.605px 223.43px 0"
    },
    id: "el7qy0fuhh3hh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 172.45a4.21 4.21 0 0 1 .58.94c.35.62.82 1.52 1.4 2.65 1.14 2.25 2.63 5.41 4.22 8.92l4 9 1.23 2.73a3.84 3.84 0 0 1 .4 1 5.49 5.49 0 0 1-.58-.93c-.35-.62-.82-1.53-1.38-2.66-1.12-2.27-2.58-5.44-4.16-9l-4.07-9c-.49-1.07-.91-2-1.25-2.72a4.94 4.94 0 0 1-.39-.93z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "420.915px 185.07px 0"
    },
    id: "el2mba1hkeg3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.22 197.71c-.07-.13 6.3-3.5 14.21-7.53s14.38-7.2 14.45-7.07-6.3 3.5-14.21 7.53-14.39 7.2-14.45 7.07z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "442.55px 190.41px 0"
    },
    id: "elcvuu2irvih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.72 235.08a4.87 4.87 0 0 1 1.09-.27l3-.57c2.52-.49 6-1.18 9.83-2.07s7.27-1.81 9.75-2.49l2.94-.81a5.62 5.62 0 0 1 1.1-.24 4.17 4.17 0 0 1-1 .43c-.68.25-1.67.58-2.9 1-2.46.78-5.89 1.75-9.73 2.64s-7.34 1.53-9.89 1.93c-1.28.19-2.31.33-3 .41a4.31 4.31 0 0 1-1.19.04z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "429.575px 231.867px 0"
    },
    id: "el4k7yapc6k8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.7 214.88a5 5 0 0 1 .75.72c.46.48 1.11 1.19 1.91 2.08 1.59 1.77 3.76 4.24 6.14 7s4.51 5.26 6 7.09c.76.92 1.37 1.67 1.78 2.19a3.67 3.67 0 0 1 .6.85 4.46 4.46 0 0 1-.75-.72 96.93 96.93 0 0 1-1.91-2.08c-1.59-1.77-3.77-4.24-6.14-7s-4.51-5.26-6-7.09c-.76-.92-1.37-1.66-1.78-2.19a3.31 3.31 0 0 1-.6-.85z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "407.29px 224.845px 0"
    },
    id: "eltzxj6sqr347",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.47 246.48a6.31 6.31 0 0 1 .95.93l2.46 2.65c2.05 2.26 4.86 5.4 7.94 8.9s5.85 6.67 7.83 9l2.33 2.77a6.77 6.77 0 0 1 .8 1.06 6.6 6.6 0 0 1-1-.93l-2.45-2.65c-2.05-2.26-4.86-5.41-7.94-8.9s-5.85-6.67-7.83-9l-2.33-2.77a6.52 6.52 0 0 1-.76-1.06z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "394.625px 259.135px 0"
    },
    id: "eljarmk77766m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.41 271a8.45 8.45 0 0 1 1.38-.38l3.77-.86c3.18-.73 7.58-1.76 12.4-3s9.15-2.51 12.29-3.43l3.71-1.09a7.74 7.74 0 0 1 1.38-.35 6.61 6.61 0 0 1-1.32.54c-.86.31-2.11.74-3.66 1.25-3.11 1-7.44 2.33-12.27 3.59s-9.25 2.24-12.46 2.88c-1.6.32-2.9.56-3.81.7a6.88 6.88 0 0 1-1.41.15z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "422.875px 266.445px 0"
    },
    id: "elkywctt64q9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.3 77.61a11.25 11.25 0 0 1 8.78-.75 19.87 19.87 0 0 1 7.65 4.7c4.28 4 7 10.13 8.64 15.75-6.34 1.39-13-2.14-16.26-4.14-5.16-3.17-12.56-12-8.81-15.56",
    style: {
      fill: "#ebebeb",
      transformOrigin: "138.324px 86.9623px 0"
    },
    id: "el209o8tkvine",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.45 98.44a9.58 9.58 0 0 1-5.45-7.92 12.73 12.73 0 0 1 3.23-9.31 5.36 5.36 0 0 1 4-2.21 4.08 4.08 0 0 1 3.38 2.42 8.32 8.32 0 0 1 .61 4.28c-.39 5-1.68 9.75-5.69 12.74",
    style: {
      fill: "#ebebeb",
      transformOrigin: "162.628px 88.72px 0"
    },
    id: "elmiwx3ondh9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.39 114.38s-.33-.27-.85-.84-1.27-1.4-2.15-2.46a40.43 40.43 0 0 1-5.82-9.09 20.57 20.57 0 0 1-1.88-10.6 14.48 14.48 0 0 1 .74-3.21 4.52 4.52 0 0 1 .51-1.09 25.42 25.42 0 0 0-.88 4.33 21.38 21.38 0 0 0 2 10.35 45.07 45.07 0 0 0 5.64 9.08l2 2.56a5.35 5.35 0 0 1 .69.97z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "166.999px 100.735px 0"
    },
    id: "elagmz499xij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.53 83.85a2.24 2.24 0 0 1 .45.25l1.24.8c1.07.7 2.6 1.75 4.48 3.06 3.75 2.62 8.86 6.36 14.39 10.63s10.46 8.25 14 11.16l4.16 3.47 1.12 1a1.87 1.87 0 0 1 .36.36 2 2 0 0 1-.43-.28l-1.18-.89-4.27-3.41c-3.59-2.84-8.55-6.77-14.07-11s-10.6-8-14.3-10.74l-4.38-3.19-1.18-.88c-.27-.19-.4-.32-.39-.34z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "152.63px 99.215px 0"
    },
    id: "elqyquf7cddvc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.31 107.67a22.48 22.48 0 0 0-20.52-.48c-1.62.8-3.34 2.17-3.21 4s2 2.92 3.78 3.44a19.19 19.19 0 0 0 20.26-6.55",
    style: {
      fill: "#ebebeb",
      transformOrigin: "148.597px 110.15px 0"
    },
    id: "elkrj3uhze8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64 110.05a4.65 4.65 0 0 1 1-.58 7.71 7.71 0 0 1 1.24-.57 13.55 13.55 0 0 1 1.72-.61 15.94 15.94 0 0 1 2.14-.53 23 23 0 0 1 2.51-.35 26.94 26.94 0 0 1 5.8.27 27.93 27.93 0 0 1 5.58 1.59 25.43 25.43 0 0 1 4.2 2.18 18.21 18.21 0 0 1 1.5 1 11.16 11.16 0 0 1 1.06.85 4.87 4.87 0 0 1 .84.81c-.06.09-1.31-1-3.59-2.39a28.34 28.34 0 0 0-9.64-3.52 27.86 27.86 0 0 0-5.67-.31 24.67 24.67 0 0 0-2.47.29 17.74 17.74 0 0 0-2.12.46c-2.6.7-4.06 1.52-4.1 1.41z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "158.435px 110.737px 0"
    },
    id: "ellzd98txt50g",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-6",
    style: {
      transformOrigin: "250.415px 454.89px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) lightSpeedRight",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448 454.89c0 .15-88.46.26-197.56.26s-197.61-.15-197.61-.26 88.44-.26 197.57-.26 197.6.12 197.6.26z",
    style: {
      fill: "#263238",
      transformOrigin: "250.415px 454.89px 0"
    },
    id: "el84p06gihf8w",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6",
    style: {
      transformOrigin: "79.0617px 143.32px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideRight",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.92 153.43s.15.18.4.54l1.09 1.57 4.12 6a.12.12 0 0 1 0 .17.11.11 0 0 1-.07 0H93.91a.15.15 0 0 1-.15-.14.11.11 0 0 1 0-.08l.26.22a24.82 24.82 0 0 1-11 5.78 23.81 23.81 0 0 1-7.11.57 23.48 23.48 0 0 1-7.47-1.62 25.39 25.39 0 0 1-7-4.1 24.42 24.42 0 0 1-5.44-6.42 24.8 24.8 0 0 1 5.49-31.66 24.95 24.95 0 0 1 28-2.62 25 25 0 0 1 8.87 8.44 24.64 24.64 0 0 1 3.51 9.49c.06.37.11.73.16 1.09s0 .72.07 1.06c0 .7.08 1.37.06 2a23.88 23.88 0 0 1-.32 3.49 23.6 23.6 0 0 1-1.27 4.67c-.2.51-.37.91-.49 1.15a2.37 2.37 0 0 1-.2.39 2.54 2.54 0 0 1 .15-.4c.1-.27.26-.66.44-1.18a26 26 0 0 0 1.17-4.66 24 24 0 0 0 .27-3.46c0-.64-.06-1.3-.08-2 0-.34 0-.69-.08-1.05l-.17-1.08a24.44 24.44 0 0 0-39.8-15 24.71 24.71 0 0 0-8.26 14 24.44 24.44 0 0 0 2.89 17A24.11 24.11 0 0 0 61.8 162a25.1 25.1 0 0 0 6.83 4 23.12 23.12 0 0 0 7.37 1.67 23.68 23.68 0 0 0 7-.53 24.52 24.52 0 0 0 10.88-5.63.16.16 0 0 1 .24 0 .15.15 0 0 1 0 .2l-.26-.23a1.73 1.73 0 0 1 .53-.07h5.84l5.23.06-.1.19c-1.74-2.65-3.1-4.71-4-6.14l-1-1.6c-.36-.31-.44-.49-.44-.49z",
    style: {
      fill: "#263238",
      transformOrigin: "79.0617px 143.32px 0"
    },
    id: "el9t4owk43wvq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.33 141.68a5.32 5.32 0 0 0 3.17-4.92 5 5 0 1 0-10 0 5.32 5.32 0 0 0 3.18 5c-7.67 1.15-7.32 9.48-7.32 9.48l18.13.09s.44-8.51-7.16-9.65z",
    style: {
      fill: "#faa64b",
      transformOrigin: "77.4261px 141.545px 0"
    },
    id: "elt4w1c3k2mh8",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-6",
    style: {
      transformOrigin: "287.14px 214.865px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) slideDown",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fafafa",
      transformOrigin: "287.12px 214.905px 0"
    },
    id: "elx5aavdh1mps",
    className: "animable",
    d: "M168.67 52.1h236.9v325.61h-236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "314.92px 226.16px 0"
    },
    id: "elrzbewr8obf",
    className: "animable",
    d: "M264.1 217.7h101.64v16.92H264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.07 230.22a3.24 3.24 0 1 1 3.24-3.24 3.24 3.24 0 0 1-3.24 3.24zm0-6.23a3 3 0 1 0 3 3 3 3 0 0 0-3-2.99z",
    style: {
      fill: "#263238",
      transformOrigin: "274.07px 226.98px 0"
    },
    id: "elw5cn9fdpyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.34 227.26c0 .14-13.5.26-30.15.26s-30.19-.12-30.19-.26 13.5-.26 30.16-.26 30.18.11 30.18.26z",
    style: {
      fill: "#263238",
      transformOrigin: "314.17px 227.26px 0"
    },
    id: "eljnvxjlwg9cp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "287.12px 110.835px 0"
    },
    id: "elznpspt4psy",
    className: "animable",
    d: "M168.67 80.49h236.9v60.69h-236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "287.12px 60.95px 0"
    },
    id: "eleg34hx1gn85",
    className: "animable",
    d: "M168.67 52.1h236.9v17.7h-236.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.04,
    cy: 60.95,
    r: 2.38,
    style: {
      fill: "#263238",
      transformOrigin: "177.04px 60.95px 0"
    },
    id: "el8xb99tmpm0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.25 60.44a2.38 2.38 0 1 1-2.38-2.38 2.39 2.39 0 0 1 2.38 2.38z",
    style: {
      fill: "#263238",
      transformOrigin: "194.87px 60.44px 0"
    },
    id: "elzn2glj8zqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.77 60.44a2.38 2.38 0 1 1-2.38-2.38 2.39 2.39 0 0 1 2.38 2.38z",
    style: {
      fill: "#263238",
      transformOrigin: "186.39px 60.44px 0"
    },
    id: "elq9t5mefrlj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "287.12px 75.145px 0"
    },
    id: "el8x9sl5eq4n5",
    className: "animable",
    d: "M168.67 69.8h236.9v10.69h-236.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 181.22c0 .14-7.93.26-17.71.26s-17.72-.12-17.72-.26 7.93-.26 17.72-.26 17.71.11 17.71.26z",
    style: {
      fill: "#263238",
      transformOrigin: "232.375px 181.22px 0"
    },
    id: "elzak52mv9aj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.09 189.53c0 .15-7.93.27-17.71.27s-17.72-.12-17.72-.27 7.93-.26 17.72-.26 17.71.12 17.71.26z",
    style: {
      fill: "#263238",
      transformOrigin: "232.375px 189.535px 0"
    },
    id: "elusew14l3dw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.76 196.41a95.23 95.23 0 0 1-10 .26 95.23 95.23 0 0 1-10.05-.26 98.58 98.58 0 0 1 10.05-.26 98.58 98.58 0 0 1 10 .26z",
    style: {
      fill: "#263238",
      transformOrigin: "224.735px 196.412px 0"
    },
    id: "el1o34in2jew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "315.65px 165.005px 0"
    },
    id: "elbzyp8z3lzhf",
    className: "animable",
    d: "M265.11 151.68h101.08v26.65H265.11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.32 191.15a5.26 5.26 0 1 1-5.25-5.25 5.25 5.25 0 0 1 5.25 5.25z",
    style: {
      fill: "#e0e0e0",
      transformOrigin: "274.06px 191.16px 0"
    },
    id: "ellee3vyviazr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.74 187.38c0 .14-16.93.26-37.81.26s-37.82-.12-37.82-.26 16.93-.26 37.82-.26 37.81.11 37.81.26z",
    style: {
      fill: "#263238",
      transformOrigin: "327.925px 187.38px 0"
    },
    id: "eld56cvem852a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.32 194.88c0 .15-8.78.26-19.6.26s-19.61-.11-19.61-.26 8.78-.26 19.61-.26 19.6.12 19.6.26z",
    style: {
      fill: "#263238",
      transformOrigin: "309.715px 194.88px 0"
    },
    id: "ellzcb91fshe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#faa64b",
      transformOrigin: "355.68px 204.775px 0"
    },
    id: "el6rczfq4uh16",
    className: "animable",
    d: "M345.62 203.39h20.12v2.77h-20.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#faa64b",
      transformOrigin: "355.68px 269.245px 0"
    },
    id: "elgc1vah70h4i",
    className: "animable",
    d: "M345.62 267.86h20.12v2.77h-20.12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.62 243.08c0 .15-17.61.26-39.34.26s-39.35-.11-39.35-.26 17.62-.26 39.35-.26 39.34.12 39.34.26z",
    style: {
      fill: "#263238",
      transformOrigin: "306.275px 243.08px 0"
    },
    id: "elk4qy10w3e5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.62 249.83c0 .15-17.61.26-39.34.26s-39.35-.11-39.35-.26 17.62-.26 39.35-.26 39.34.12 39.34.26z",
    style: {
      fill: "#263238",
      transformOrigin: "306.275px 249.83px 0"
    },
    id: "el9dzu9fc1jhl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.62 256.58c0 .15-17.61.26-39.34.26s-39.35-.11-39.35-.26 17.62-.26 39.35-.26 39.34.12 39.34.26z",
    style: {
      fill: "#263238",
      transformOrigin: "306.275px 256.58px 0"
    },
    id: "elzcgi8nv7vli",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22 268.74c0 .14-5.49.26-12.27.26s-12.26-.12-12.26-.26 5.49-.27 12.26-.27 12.27.12 12.27.27z",
    style: {
      fill: "#263238",
      transformOrigin: "279.955px 268.735px 0"
    },
    id: "elqfe9r2ng67",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455a64",
      transformOrigin: "314.92px 316.2px 0"
    },
    id: "elzvv7wjx3cag",
    className: "animable",
    d: "M264.1 285.77h101.64v60.86H264.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "314.92px 328.58px 0"
    },
    id: "elx3mf6jqcfcn",
    className: "animable",
    d: "m264.1 346.63 42.18-27.6 12.92 9.2 26.42-17.7 20.12 15.57v20.53H264.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.12,
    cy: 306.7,
    r: 7.2,
    style: {
      fill: "#263238",
      transformOrigin: "322.12px 306.7px 0"
    },
    id: "el80vioqs2yg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "217.845px 217.135px 0"
    },
    id: "el0va8z89ex9bp",
    className: "animable",
    d: "M212.55 211.84h10.59v10.59h-10.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "230.735px 217.135px 0"
    },
    id: "elo46n3pibk17",
    className: "animable",
    d: "M225.44 211.84h10.59v10.59h-10.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "243.715px 217.135px 0"
    },
    id: "ely0c6r1w054",
    className: "animable",
    d: "M238.42 211.84h10.59v10.59h-10.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "217.845px 229.785px 0"
    },
    id: "el00jufig57kjx9",
    className: "animable",
    d: "M212.55 224.49h10.59v10.59h-10.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5f5f5",
      transformOrigin: "230.735px 229.785px 0"
    },
    id: "eljcsumbvxirp",
    className: "animable",
    d: "M225.44 224.49h10.59v10.59h-10.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "243.715px 229.785px 0"
    },
    id: "el68io2056zqj",
    className: "animable",
    d: "M238.42 224.49h10.59v10.59h-10.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "217.845px 242.445px 0"
    },
    id: "el25s5xsaecqi",
    className: "animable",
    d: "M212.55 237.15h10.59v10.59h-10.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      transformOrigin: "230.735px 242.445px 0"
    },
    id: "elaa768idfwz",
    className: "animable",
    d: "M225.44 237.15h10.59v10.59h-10.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e0e0e0",
      transformOrigin: "243.715px 242.445px 0"
    },
    id: "el1cijq18cqop",
    className: "animable",
    d: "M238.42 237.15h10.59v10.59h-10.59z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elahyeq6ukfx7"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#faa64b",
      transformOrigin: "232.305px 123.645px 0",
      transform: "rotate(-.35deg)"
    },
    className: "animable",
    id: "elbeq8bta3ht5",
    d: "M202.93 94.27h58.75v58.75h-58.75z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elaev7l9xjewu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.75 124.91a1.09 1.09 0 0 0 .09 1.53 1.08 1.08 0 0 0 1.44-1.61 1.09 1.09 0 0 0-1.53.08z",
    style: {
      opacity: 0.2,
      transformOrigin: "245.559px 125.635px 0"
    },
    className: "animable",
    id: "el9cbjlv1f7zq"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elajasb6cnzal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.33 123.77a2.53 2.53 0 0 0-3 0c-.32.25-.44.49-.38.54s.85-.41 1.87-.4 1.76.56 1.87.43-.04-.34-.36-.57z",
    style: {
      opacity: 0.2,
      transformOrigin: "245.83px 123.819px 0"
    },
    className: "animable",
    id: "elpizvy8cwjji"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elb7w4vh5ekdt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.26 125.28a1.09 1.09 0 0 0-1.48.37 1.07 1.07 0 0 0 .36 1.48 1.09 1.09 0 0 0 1.49-.36 1.1 1.1 0 0 0-.37-1.49z",
    style: {
      opacity: 0.2,
      transformOrigin: "234.7px 126.209px 0"
    },
    className: "animable",
    id: "elnqw9ag0bwmj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4nb36635b5d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.22 124.74a2.44 2.44 0 0 0-1.49-.5 2.57 2.57 0 0 0-1.5.48c-.32.25-.44.48-.38.54s.85-.41 1.88-.4 1.75.55 1.87.42-.06-.28-.38-.54z",
    style: {
      opacity: 0.2,
      transformOrigin: "234.736px 124.77px 0"
    },
    className: "animable",
    id: "elk4eueceyuw"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ela9v8nyj6c2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.42 130.06a28.18 28.18 0 0 0-2.32-5.25 28.58 28.58 0 0 0 1.78 5.45c.28.72.56 1.4.82 2.08a1.41 1.41 0 0 1 .2.76c0 .15-.23.21-.5.24a5 5 0 0 0-1.65.36 5.07 5.07 0 0 0 1.69.05 2.15 2.15 0 0 0 .46-.06.74.74 0 0 0 .46-.43 1.73 1.73 0 0 0-.16-1.11c-.2-.68-.51-1.37-.78-2.09z",
    style: {
      opacity: 0.2,
      transformOrigin: "241.745px 129.304px 0"
    },
    className: "animable",
    id: "elhbr1gtl68qe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7g04p6xvwiw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.73 143.55s2.32 5.34 9.73 4.62v-1.92a17.25 17.25 0 0 1-9.73-2.7z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "236.595px 145.893px 0"
    },
    className: "animable",
    id: "elgqq3m60gd2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eli7fb7wtcfk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m247.77 116.11-.1.07h-.06a12.82 12.82 0 0 1-9.8-.21c-4-1.61-8.56-2.19-9.49-1.34s-.82 4.84-4.54 6.3c0 0 .84 7.35-2.07 7.5h-.06c-.08-1.68-.15-3.24-.15-3.24a4.86 4.86 0 0 0-.61-.14 5.27 5.27 0 0 0-2.18.07c-1.16.33-2.22 1.27-2.13 3.67.15 4 3.33 4.08 4.67 3.85l1 20.42 19.29-.12c.07-1.56 0-2.67 0-4.05v-.74c-7.41.72-9.73-4.62-9.73-4.62a17.25 17.25 0 0 0 9.7 2.7v.1c.14 0 7.41-1.27 7.45-8.63-.03-5.52-.8-16.41-1.19-21.59zM220 130.89a1 1 0 0 1-.8.16 2.31 2.31 0 0 1-1.38-2.14 3 3 0 0 1 .26-1.43 1.24 1.24 0 0 1 .89-.82.69.69 0 0 1 .5.11.59.59 0 0 1 .21.31c.05.21 0 .31-.06.3s0-.11-.07-.25a.45.45 0 0 0-.53-.22 1 1 0 0 0-.64.7 2.93 2.93 0 0 0-.2 1.28 2.18 2.18 0 0 0 1.09 1.92.9.9 0 0 0 .66 0c.14-.07.21-.15.23-.14s.04.09-.16.22zm25-9.33c1.46-.08 2.48.64 2.35.88s-1.11.09-2.29.16-2.16.34-2.3.08.75-1.05 2.24-1.12zm-13.64.23c0-.3 1.06-.44 2.28-.49l1.54-.08c.38 0 .64 0 .72.09s-.09.39-.51.62a4.38 4.38 0 0 1-1.7.41c-1.37.05-2.39-.27-2.37-.55zm4.31 5a1.09 1.09 0 0 1-1.49.36 1.07 1.07 0 0 1-.36-1.48 1.09 1.09 0 0 1 1.48-.37 1.1 1.1 0 0 1 .33 1.47zm1-1.49c-.12.13-.85-.42-1.87-.42s-1.77.53-1.88.4.06-.29.38-.54a2.57 2.57 0 0 1 1.5-.48 2.44 2.44 0 0 1 1.49.5c.25.24.36.47.31.52zm2.79 11.06c-1.36-.46-2-1.54-1.84-1.6s.82.72 2 1.11a16.36 16.36 0 0 0 2.26.35 2.55 2.55 0 0 1-2.49.12zm4-3.08a.74.74 0 0 1-.46.43 2.15 2.15 0 0 1-.46.06 5.07 5.07 0 0 1-1.69-.05 5 5 0 0 1 1.65-.36c.27 0 .48-.09.5-.24a1.41 1.41 0 0 0-.2-.76c-.26-.68-.54-1.36-.82-2.08a28.58 28.58 0 0 1-1.78-5.45 28.18 28.18 0 0 1 2.32 5.25c.27.72.53 1.41.78 2.09a1.73 1.73 0 0 1 .06 1.09zm3-6.91a1.08 1.08 0 0 1-1.52.09 1.08 1.08 0 1 1 1.44-1.61 1.08 1.08 0 0 1-.02 1.5zm1.34-2c-.11.13-.84-.43-1.87-.43s-1.76.53-1.87.4.06-.29.38-.54a2.53 2.53 0 0 1 3 0c.21.2.32.46.26.52z",
    style: {
      fill: "#fff",
      opacity: 0.2,
      transformOrigin: "232.767px 133.65px 0"
    },
    className: "animable",
    id: "eljw1ytx593e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhl69pbpo1ns"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.31 130.81a2.18 2.18 0 0 1-1.09-1.92 2.93 2.93 0 0 1 .2-1.28 1 1 0 0 1 .64-.7.45.45 0 0 1 .53.22c.07.14 0 .24.07.25s.11-.09.06-.3a.59.59 0 0 0-.21-.31.69.69 0 0 0-.5-.11 1.24 1.24 0 0 0-.89.82 3 3 0 0 0-.26 1.43 2.31 2.31 0 0 0 1.38 2.14 1 1 0 0 0 .8-.16c.16-.13.18-.25.16-.26s-.09.07-.23.14a.9.9 0 0 1-.66.04z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      transformOrigin: "219.03px 128.863px 0"
    },
    className: "animable",
    id: "el2b555xughay"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5g6fe5v28hq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.15 110.47c.11-.08-.38-.84-1.4-1.15s-1.86 0-1.8.17.79.06 1.65.33 1.4.75 1.55.65z",
    style: {
      opacity: 0.2,
      transformOrigin: "219.556px 109.836px 0"
    },
    className: "animable",
    id: "elmfzmadmymy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj57ki1pgd6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.93 110.7a17.27 17.27 0 0 1-.72-2.13 12.6 12.6 0 0 0-.4-2.3 3.65 3.65 0 0 0-.11 2.41 3.47 3.47 0 0 0 1.14 2.07h.08c.01 0 .02-.02.01-.05z",
    style: {
      opacity: 0.2,
      transformOrigin: "221.24px 108.51px 0"
    },
    className: "animable",
    id: "elwoccpopi7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el99o8dng76ub"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245 122.6c1.18-.07 2.17.12 2.29-.16s-.89-1-2.35-.88-2.4.88-2.24 1.12 1.13-.03 2.3-.08z",
    style: {
      opacity: 0.2,
      transformOrigin: "244.991px 122.162px 0"
    },
    className: "animable",
    id: "elwyo335yhyw"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwy5u0a5sj6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.65 122.34a4.38 4.38 0 0 0 1.7-.41c.42-.23.59-.51.51-.62s-.34-.1-.72-.09l-1.54.08c-1.22 0-2.27.19-2.28.49s1 .6 2.33.55z",
    style: {
      opacity: 0.2,
      transformOrigin: "233.6px 121.78px 0"
    },
    className: "animable",
    id: "elyvb7woco5c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elffnskr4qqhf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.55 134.74c-.13.06.48 1.14 1.84 1.6a2.55 2.55 0 0 0 2.43-.14 16.36 16.36 0 0 1-2.26-.35c-1.19-.39-1.89-1.2-2.01-1.11z",
    style: {
      opacity: 0.2,
      transformOrigin: "239.676px 135.658px 0"
    },
    className: "animable",
    id: "elk4d99mnduho"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elk9ho19bwq3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.17 104a8.52 8.52 0 0 0-9.56-1.26c-1.4.75-2.59 1.89-4.1 2.37-1.81.57-3.76.08-5.65-.06s-4.1.24-5.05 1.88c-.61 1-.58 2.45-1.41 3.35a2.22 2.22 0 0 1-.47.4v.06c0 .06 0 0-.08 0-1.17.7-2.83.5-4.19 1a4.5 4.5 0 0 0-2.87 3.72 5.34 5.34 0 0 0 1.76 4.43 8.23 8.23 0 0 1 2 2 5.43 5.43 0 0 1 .14 3.3 5.27 5.27 0 0 1 2.18-.07 4.86 4.86 0 0 1 .61.14s.07 1.56.15 3.24h.06c2.91-.15 2.07-7.5 2.07-7.5 3.72-1.46 3.61-5.45 4.54-6.3s5.49-.27 9.49 1.34a12.82 12.82 0 0 0 9.8.21h.06l.1-.07.25-.18.22-.12a5.66 5.66 0 0 0 1.84-2.34 8.51 8.51 0 0 0-1.89-9.54z",
    style: {
      opacity: 0.2,
      transformOrigin: "232.773px 115.157px 0"
    },
    className: "animable",
    id: "elkk401bqpxtj"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m405.34 52.1.23.24H168.7l.27-.26c0 121.69 0 234.34-.05 325.61l-.22-.21 236.9.21-236.9.22h-.21v-.22c0-91.27 0-203.92-.05-325.61v-.26h237.4v.23c-.14 192.62-.23 323.53-.24 325.61",
    style: {
      fill: "#263238",
      transformOrigin: "287.14px 214.865px 0"
    },
    id: "eld2dizz0ylit",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-6",
    style: {
      transformOrigin: "144.905px 302.089px 0",
      animation: "1s 1 forwards cubic-bezier(.36,-.01,.5,1.38) fadeIn",
      animationDelay: "0s"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m84.86 280.11 1.29 2.75a25.77 25.77 0 0 0 2.08 4.66 7.71 7.71 0 0 0 1.57 2 11.63 11.63 0 0 0 2.55 1.86 1 1 0 0 1 0 1.85c-.86.21-3.36-.75-5.49-3s-1.8 2.63-1.72 4.42.11 7.34-.42 7.81c-.78.68-1.65 0-1.7-1.82s-.56-7.15-1.51-7.06-.35 9.2-.35 9.2.44 1.93-.65 2.08c-2 .25-1.86-9.48-1.83-10.41 0-.64-1-.58-1 .12s.78 9.07-1.21 9.36c-1.53.21 0-8-1.11-9.66s-.54 6.36-2 6.5c-.54.06-1 0-.64-4.62s3.34-17.5 3.34-17.5l8.94 1.59",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "82.7811px 291.757px 0"
    },
    id: "elgdx8pti2r7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.35 211.92s-28 27.33-28.66 30.87S87 285.56 87 285.56l-12.8-1.27S73 235.93 77 231s20-23.41 20-23.41z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "97.1906px 246.575px 0"
    },
    id: "el9spakqhd1xp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2 236.13s-.18-.1-.37-.39a2.4 2.4 0 0 1-.38-1.41 2.44 2.44 0 0 1 1-1.92 2.55 2.55 0 0 1 2.64-.27 2.07 2.07 0 0 1 1 1.07 1.82 1.82 0 0 1 0 1.36 1.44 1.44 0 0 1-2 .68 1.2 1.2 0 0 1-.5-1.38c.13-.35.34-.44.34-.42s-.12.16-.17.46a1 1 0 0 0 .44 1.09 1.12 1.12 0 0 0 1.5-.57 1.36 1.36 0 0 0 0-1 1.56 1.56 0 0 0-.79-.83 2.15 2.15 0 0 0-2.21.2 2.19 2.19 0 0 0-1 1.62 3.12 3.12 0 0 0 .5 1.71z",
    style: {
      fill: "#eb996e",
      transformOrigin: "79.8346px 234.011px 0"
    },
    id: "eltjkb8dqp9di",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.22 142.15c-.19.53-2.65 35.87-2.65 35.87l14.18-1.08 3.51-30.75z",
    style: {
      fill: "#455a64",
      transformOrigin: "185.415px 160.085px 0"
    },
    id: "eln4zlo0ev9vo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "177.055px 159.82px 0"
    },
    id: "eln85tifygu3",
    className: "animable",
    d: "m176.57 178.02-1.91-.55 2.74-35.85 2.05.59-2.88 35.81z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.34,
    cy: 150.58,
    r: 0.83,
    style: {
      fill: "#263238",
      transformOrigin: "187.34px 150.58px 0"
    },
    id: "el70hcup52yrs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.79 195.54 25 6.49-3.95-29.62-.51-1.42-9.16-1.41 1.09-6.76a5.51 5.51 0 0 1 6.83-4.35l3 .8a7.84 7.84 0 0 1 5 4c1.73 3.4 3.43 7.12 3.27 6.8l13.4 36.36a13.74 13.74 0 0 1-1.48 14.65c-4.32 5.61-14.75 1.71-19.66.76l-32-7.05z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "189.919px 191.166px 0"
    },
    id: "elo1a8zmkvje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.91 159.44a1.6 1.6 0 0 1-.4 1.67 1.57 1.57 0 0 1-1.68.28c-1.06-.46-1.26-1.86-1.12-3s.46-2.37-.08-3.39a7.36 7.36 0 0 0-1.86-1.83 5 5 0 0 1-1.6-4.13 4.16 4.16 0 0 1 2.68-3.42c1.48-.51 3.36-.15 4.42-1.29.76-.84.74-2.13 1.32-3.11.89-1.51 2.94-1.85 4.69-1.71s3.55.6 5.24.09c1.4-.43 2.51-1.49 3.81-2.17a7.69 7.69 0 0 1 10.58 10 4.93 4.93 0 0 1-2.25 2.49",
    style: {
      fill: "#263238",
      transformOrigin: "131.878px 149.031px 0"
    },
    id: "eli97jz16be3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.66 189.28 16.56-1.28c.1-1.93 0-9.41 0-9.41s6.89-1.07 7-8-1.11-22.7-1.11-22.7a24 24 0 0 0-24.06 3l-1 .79z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "134.139px 167.612px 0"
    },
    id: "elx6ibecbmgag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46 159.71a1 1 0 0 1-.07-1.41 1 1 0 1 1 1.48 1.35 1 1 0 0 1-1.41.06z",
    style: {
      fill: "#263238",
      transformOrigin: "145.132px 158.973px 0"
    },
    id: "elukq2tvfd46n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.13 158.14c-.11.12-.78-.4-1.73-.4s-1.64.48-1.74.36.05-.27.35-.5a2.42 2.42 0 0 1 1.4-.44 2.29 2.29 0 0 1 1.38.48c.29.23.39.45.34.5z",
    style: {
      fill: "#263238",
      transformOrigin: "144.386px 157.659px 0"
    },
    id: "elod023gptcj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.2 159a1 1 0 1 1-1.38.33 1 1 0 0 1 1.38-.33z",
    style: {
      fill: "#263238",
      transformOrigin: "134.674px 159.851px 0"
    },
    id: "elhfcfbiwlbal",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.83 159c-.11.12-.79-.4-1.74-.41s-1.63.49-1.74.37.06-.27.36-.5a2.25 2.25 0 0 1 1.39-.44 2.35 2.35 0 0 1 1.38.47c.3.22.4.43.35.51z",
    style: {
      fill: "#263238",
      transformOrigin: "134.079px 158.519px 0"
    },
    id: "el13u96jhwyd6l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.63 166.8a4.72 4.72 0 0 1 1.53-.32c.25 0 .45-.08.47-.22a1.48 1.48 0 0 0-.18-.71c-.25-.63-.49-1.26-.75-1.93a26.29 26.29 0 0 1-1.63-5.06 25.58 25.58 0 0 1 2.13 4.87c.25.67.48 1.31.71 1.95a1.57 1.57 0 0 1 .14 1 .66.66 0 0 1-.43.39 1.76 1.76 0 0 1-.42.06 4.52 4.52 0 0 1-1.57-.03z",
    style: {
      fill: "#263238",
      transformOrigin: "140.574px 162.722px 0"
    },
    id: "elzfakhhamyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.55 167.85a17.25 17.25 0 0 0 4.65 1.35 2.63 2.63 0 0 1-3.09 1.05c-2.06-.76-1.56-2.4-1.56-2.4z",
    style: {
      fill: "#fff",
      transformOrigin: "138.848px 169.126px 0"
    },
    id: "el6s3xq0mup57",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19 178.44a16 16 0 0 1-9-2.55s2.12 5 9 4.34z",
    style: {
      fill: "#eb996e",
      transformOrigin: "135.69px 178.09px 0"
    },
    id: "elssw2nv5hga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.19 149.61s-4 2.33-9.67 0c-3.7-1.52-7.93-2.08-8.79-1.29s-.79 4.47-4.25 5.81c0 0 .77 7-2 7s-1.87-11.05-1.87-11.05l6.59-3.85 7.37-2 7.11.47 5.56 1.09z",
    style: {
      fill: "#263238",
      transformOrigin: "132.855px 152.68px 0"
    },
    id: "el43o3m1123xo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.82 158.82c-.12 0-4.73-1.4-4.58 3.31s4.84 3.59 4.85 3.45-.27-6.76-.27-6.76z",
    style: {
      fill: "#ffbe9d",
      transformOrigin: "119.663px 162.21px 0"
    },
    id: "el9jtc6w6yejc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.59 163.84s-.08.06-.21.13a.8.8 0 0 1-.62 0 2 2 0 0 1-1-1.79A2.79 2.79 0 0 1 119 161a.93.93 0 0 1 .59-.65.44.44 0 0 1 .5.21c.06.13 0 .23.06.23s.1-.08.06-.27a.59.59 0 0 0-.2-.29.64.64 0 0 0-.46-.11 1.15 1.15 0 0 0-.83.76 2.71 2.71 0 0 0-.24 1.32 2.13 2.13 0 0 0 1.26 2 .9.9 0 0 0 .74-.15c.11-.05.13-.2.11-.21z",
    style: {
      fill: "#eb996e",
      transformOrigin: "119.535px 162.169px 0"
    },
    id: "elxulyuidjpm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.62 144.23c-.05-.13.73-.47 1.68-.17s1.4 1 1.29 1.09-.65-.35-1.45-.59-1.48-.19-1.52-.33z",
    style: {
      fill: "#263238",
      transformOrigin: "120.112px 144.551px 0"
    },
    id: "elrzkxthyt3ac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3 141.25c.16 0 .15 1 .37 2.14s.75 2 .63 2-.89-.66-1.14-1.94a3.23 3.23 0 0 1 .14-2.2z",
    style: {
      fill: "#263238",
      transformOrigin: "121.674px 143.32px 0"
    },
    id: "elwwnsdmpgokr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.52 156.59c-.16-.23.72-1 2.08-1.05s2.31.62 2.18.86-1 .12-2.13.18-1.99.27-2.13.01z",
    style: {
      fill: "#263238",
      transformOrigin: "143.647px 156.127px 0"
    },
    id: "el8r2ckt99p97",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 155.71c-.15-.23.72-1 2.09-1.06s2.3.62 2.17.87-1 .11-2.13.17-2.04.31-2.13.02z",
    style: {
      fill: "#263238",
      transformOrigin: "133.128px 155.247px 0"
    },
    id: "elpfavl3vr97",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92 446.78-1.65 6.9s-11.27 14.64-14.75 13.93c-2.28-.47.52-4.29 4.81-15.42l.9-4.59z",
    style: {
      fill: "#455a64",
      transformOrigin: "83.3931px 457.208px 0"
    },
    id: "eln7j81vk1eb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.11 465.45a1.49 1.49 0 0 0 .6.57 2.08 2.08 0 0 0 2.16-.3 62 62 0 0 0 5.61-5.32c2.09-2.19 3.84-4.3 5.08-5.85L90 452.7l.39-.51a1.07 1.07 0 0 1 .15-.17l-.12.2-.36.52c-.31.46-.79 1.11-1.39 1.9a70.5 70.5 0 0 1-5 5.91 54 54 0 0 1-5.67 5.29 2.58 2.58 0 0 1-1.27.47 1.83 1.83 0 0 1-1-.22 1.16 1.16 0 0 1-.48-.44.52.52 0 0 1-.14-.2z",
    style: {
      fill: "#263238",
      transformOrigin: "82.825px 459.167px 0"
    },
    id: "eldhr6l760h1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.71 460.74a1.79 1.79 0 0 1 .93-.11 4.82 4.82 0 0 1 2.12.74 3.9 3.9 0 0 1 1.55 1.63 2 2 0 0 1 .24.9s-.11-.34-.37-.84a4.17 4.17 0 0 0-1.53-1.52 5.39 5.39 0 0 0-2-.77 8.58 8.58 0 0 0-.94-.03z",
    style: {
      fill: "#263238",
      transformOrigin: "79.13px 462.255px 0"
    },
    id: "elua48eozv0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.38 457.3a1.31 1.31 0 0 1-.13-.33A7.17 7.17 0 0 1 87 456a5.14 5.14 0 0 1 .53-3.14 4.91 4.91 0 0 1 2.28-2.22 3.94 3.94 0 0 1 .93-.28h.36a8.14 8.14 0 0 0-1.23.44 5 5 0 0 0-2.13 2.2 5.3 5.3 0 0 0-.57 3c.09.81.25 1.29.21 1.3z",
    style: {
      fill: "#263238",
      transformOrigin: "89.022px 453.83px 0"
    },
    id: "elqdpfkpu3jki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.25 448s-.2 1-.42 2.2a7.35 7.35 0 0 1-.58 2.17s.17-1 .38-2.2a7.12 7.12 0 0 1 .62-2.17z",
    style: {
      fill: "#263238",
      transformOrigin: "90.75px 450.185px 0"
    },
    id: "elj3m4n02fh6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.18 453.17a2.63 2.63 0 0 1 1.45 0 2.52 2.52 0 0 1 1.3.62c0 .06-.59-.24-1.35-.42s-1.39-.14-1.4-.2z",
    style: {
      fill: "#263238",
      transformOrigin: "81.555px 453.433px 0"
    },
    id: "elum5682effv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 454.35a1.77 1.77 0 0 1 1.22-.05 1.79 1.79 0 0 1 1.07.59c0 .05-.49-.24-1.12-.39s-1.17-.09-1.17-.15z",
    style: {
      fill: "#263238",
      transformOrigin: "81.145px 454.555px 0"
    },
    id: "elwvjuetf6fod",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.05 455.83a1.83 1.83 0 0 1 2.33.53 5.74 5.74 0 0 0-1.11-.49 5.33 5.33 0 0 0-1.22-.04z",
    style: {
      fill: "#263238",
      transformOrigin: "80.215px 455.988px 0"
    },
    id: "el8q895exfbmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 452.67s.52-.14 1.32-.45a9.78 9.78 0 0 0 1.36-.66 7.85 7.85 0 0 0 .75-.48c.23-.17.48-.41.47-.68s-.34-.41-.6-.34a1.59 1.59 0 0 0-.69.46c-.42.39-.77.76-1.06 1.08-.58.65-.9 1.08-.92 1.06a1.08 1.08 0 0 1 .19-.33 9.79 9.79 0 0 1 .62-.82 12.56 12.56 0 0 1 1-1.13 1.63 1.63 0 0 1 .78-.52.66.66 0 0 1 .85.53 1.13 1.13 0 0 1-.56.86c-.26.18-.52.34-.77.48a9.67 9.67 0 0 1-1.41.63 8.25 8.25 0 0 1-1 .27 1.44 1.44 0 0 1-.33.04z",
    style: {
      fill: "#263238",
      transformOrigin: "83.035px 451.25px 0"
    },
    id: "elwrc8kef616k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.55 452.53s-.08-.49-.21-1.26A5.46 5.46 0 0 0 81 450a3.13 3.13 0 0 0-.42-.67c-.17-.19-.44-.36-.64-.23s-.24.43-.21.68a3.17 3.17 0 0 0 .22.76 4.5 4.5 0 0 0 .73 1.13c.53.58.93.86.91.89a1 1 0 0 1-.3-.18 4.47 4.47 0 0 1-.72-.61 4.28 4.28 0 0 1-.8-1.16 2.87 2.87 0 0 1-.24-.8.88.88 0 0 1 .3-.9.76.76 0 0 1 .9.29 2.74 2.74 0 0 1 .44.72 5 5 0 0 1 .36 1.36c.05.39.06.71.07.93a1.18 1.18 0 0 1-.05.32z",
    style: {
      fill: "#263238",
      transformOrigin: "80.5516px 450.711px 0"
    },
    id: "elpn4imcmorp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 450.27v-9.2l-17.22-.2-.22 13.45 1.07.08c4.75.32 24.17 1.3 27.36.37 3.63-1.03-10.99-4.5-10.99-4.5z",
    style: {
      fill: "#455a64",
      transformOrigin: "145.065px 448.015px 0"
    },
    id: "el0e78ioycoq48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.39 453.92h.3l.85.07 3.13.17c2.64.13 6.29.26 10.33.31s7.69 0 10.34 0l3.13-.09h1.15H145c-4.04 0-7.68-.17-10.33-.26l-3.13-.11h-.85z",
    style: {
      fill: "#263238",
      transformOrigin: "145.005px 454.206px 0"
    },
    id: "elzjxmwlivtof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.59 454.69a6.85 6.85 0 0 1 .6-1.49 6.33 6.33 0 0 1 1.09-1.18 2.22 2.22 0 0 0-1.26 1.07 2.3 2.3 0 0 0-.43 1.6z",
    style: {
      fill: "#263238",
      transformOrigin: "154.429px 453.355px 0"
    },
    id: "el5bep89aswr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.54 452c.05 0 .3-.26.55-.65s.43-.74.38-.77-.3.26-.55.66-.43.76-.38.76z",
    style: {
      fill: "#263238",
      transformOrigin: "149.005px 451.289px 0"
    },
    id: "elumhlvhnvemr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.16 451.29s.31-.14.61-.4.51-.51.47-.55-.31.13-.61.39-.51.52-.47.56z",
    style: {
      fill: "#263238",
      transformOrigin: "147.7px 450.812px 0"
    },
    id: "elr4a4zk13xz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.3 449.65c0 .06.4.12.89.13a2.21 2.21 0 0 0 .9-.08c0-.06-.4-.12-.89-.13a2 2 0 0 0-.9.08z",
    style: {
      fill: "#263238",
      transformOrigin: "147.195px 449.673px 0"
    },
    id: "el80p27j9ocaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 448.5a1.72 1.72 0 0 0 1 .31 1.68 1.68 0 0 0 1-.13 5.54 5.54 0 0 0-1-.08 5.06 5.06 0 0 0-1-.1z",
    style: {
      fill: "#263238",
      transformOrigin: "147px 448.668px 0"
    },
    id: "elv8624ap82b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.14 450.55a3.4 3.4 0 0 0 1.11 0 7 7 0 0 0 1.18-.25 2.92 2.92 0 0 0 .68-.27.61.61 0 0 0 .28-.34.43.43 0 0 0-.16-.44 2 2 0 0 0-2.52.56 2.07 2.07 0 0 0-.37.73c-.05.19-.05.3 0 .3a3.37 3.37 0 0 1 .51-.94 2.09 2.09 0 0 1 1-.6 1.71 1.71 0 0 1 1.31.11c.18.13.11.34-.09.45a3.21 3.21 0 0 1-.63.26 7 7 0 0 1-1.14.28c-.73.12-1.16.12-1.16.15z",
    style: {
      fill: "#263238",
      transformOrigin: "150.771px 449.931px 0"
    },
    id: "elktaeog19r0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43 450.61a1.1 1.1 0 0 0 .14-.77 1.94 1.94 0 0 0-.29-.81 1.13 1.13 0 0 0-.92-.58.45.45 0 0 0-.35.51 1.3 1.3 0 0 0 .19.5 3.45 3.45 0 0 0 .51.67 1.55 1.55 0 0 0 .63.46s-.22-.2-.52-.56a3.88 3.88 0 0 1-.46-.67c-.14-.23-.24-.65 0-.7s.56.25.73.48a1.82 1.82 0 0 1 .3.72 4.44 4.44 0 0 1 .04.75z",
    style: {
      fill: "#263238",
      transformOrigin: "148.797px 449.53px 0"
    },
    id: "el3d1et8bv3af",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.8 449.21s.5 0 1.28.06a5.66 5.66 0 0 1 2.76 1.18 5.56 5.56 0 0 1 1.7 2.47c.26.75.27 1.24.31 1.24s0-.13 0-.35a5.22 5.22 0 0 0-1.89-3.52 5.29 5.29 0 0 0-2.88-1.17 4.66 4.66 0 0 0-1 0 1.26 1.26 0 0 0-.28.09z",
    style: {
      fill: "#263238",
      transformOrigin: "133.834px 451.627px 0"
    },
    id: "elnjrbcn32q6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.68 442.07a62.51 62.51 0 0 0-.18 7.07 56.85 56.85 0 0 0 .18-7.07z",
    style: {
      fill: "#263238",
      transformOrigin: "132.594px 445.605px 0"
    },
    id: "el0ehct66xaonp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.07 452.61a10 10 0 0 0 2.51.28 10.18 10.18 0 0 0 2.52-.17c0-.06-1.13 0-2.52 0s-2.51-.17-2.51-.11z",
    style: {
      fill: "#263238",
      transformOrigin: "141.585px 452.752px 0"
    },
    id: "elkw8qh3eb5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.69 452.56s.09.24.2.5.17.49.23.48.09-.27 0-.57-.39-.45-.43-.41z",
    style: {
      fill: "#263238",
      transformOrigin: "135.933px 453.047px 0"
    },
    id: "el9q72vxarxxd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.44 451s.07.22.24.4.35.3.4.26-.07-.22-.25-.4-.35-.34-.39-.26z",
    style: {
      fill: "#263238",
      transformOrigin: "134.766px 451.323px 0"
    },
    id: "el6q2gwqh4y52",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.63 450.21c0 .06.24.06.49.15s.43.23.48.19-.1-.27-.41-.38-.58-.01-.56.04z",
    style: {
      fill: "#263238",
      transformOrigin: "133.119px 450.339px 0"
    },
    id: "eltqf5gh98sv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.34 449.85c0 .06.07.15.21.2s.28.06.3 0-.07-.14-.22-.2-.27-.05-.29 0z",
    style: {
      fill: "#263238",
      transformOrigin: "131.596px 449.95px 0"
    },
    id: "el4j83nonqmxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      transformOrigin: "116.705px 357.835px 0"
    },
    id: "elbsfee57t1ba",
    className: "animable",
    d: "m159.74 267.66-8.04 178.65-26.82.56 4.46-149.56-30.17 150.7h-25.5l34.05-180.35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.09 445.43c.14 0 .2.37.13.78s-.24.72-.38.7-.2-.38-.13-.79.29-.72.38-.69z",
    style: {
      fill: "#455a64",
      transformOrigin: "79.965px 446.169px 0"
    },
    id: "el7ql0ye06sz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.07 439.58c.14 0 .15.7 0 1.5s-.36 1.45-.5 1.42-.15-.69 0-1.5.36-1.44.5-1.42z",
    style: {
      fill: "#455a64",
      transformOrigin: "80.82px 441.04px 0"
    },
    id: "elzhcgxbl7hd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.05 433.73c.14 0 .15.7 0 1.51s-.36 1.44-.5 1.41-.15-.69 0-1.5.36-1.44.5-1.42z",
    style: {
      fill: "#455a64",
      transformOrigin: "81.8px 435.19px 0"
    },
    id: "el375g8fnfz18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 427.88c.14 0 .14.7 0 1.51s-.36 1.44-.51 1.41-.14-.69 0-1.5.4-1.44.51-1.42z",
    style: {
      fill: "#455a64",
      transformOrigin: "82.7431px 429.34px 0"
    },
    id: "el11okjsf3oft",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 422c.14 0 .15.7 0 1.5s-.36 1.45-.5 1.42-.15-.69 0-1.5.38-1.42.5-1.42z",
    style: {
      fill: "#455a64",
      transformOrigin: "83.75px 423.461px 0"
    },
    id: "eldisc20mlgae",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 416.18c.14 0 .15.7 0 1.5s-.36 1.45-.5 1.42-.15-.69 0-1.5.37-1.45.5-1.42z",
    style: {
      fill: "#455a64",
      transformOrigin: "84.75px 417.64px 0"
    },
    id: "elqxepfwr9ygm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 410.33c.14 0 .15.7 0 1.5s-.36 1.45-.51 1.42-.14-.69 0-1.5.37-1.45.51-1.42z",
    style: {
      fill: "#455a64",
      transformOrigin: "85.745px 411.79px 0"
    },
    id: "elu77j1tqktrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 404.48c.14 0 .15.7 0 1.51s-.36 1.44-.5 1.42-.15-.7 0-1.51.35-1.45.5-1.42z",
    style: {
      fill: "#455a64",
      transformOrigin: "86.75px 405.945px 0"
    },
    id: "el8ogegsl0uhd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 398.63c.14 0 .14.7 0 1.51s-.37 1.44-.51 1.41-.14-.69 0-1.5.36-1.44.51-1.42z",
    style: {
      fill: "#455a64",
      transformOrigin: "87.745px 400.09px 0"
    },
    id: "elnvx0lmjesso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 392.78c.14 0 .14.7 0 1.51s-.37 1.44-.51 1.42-.15-.7 0-1.51.36-1.44.51-1.42z",
    style: {
      fill: "#455a64",
      transformOrigin: "88.7431px 394.245px 0"
    },
    id: "elm27i769065",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 386.93c.15 0 .15.7 0 1.51s-.37 1.44-.51 1.42-.14-.7 0-1.51.36-1.44.51-1.42z",
    style: {
      fill: "#455a64",
      transformOrigin: "89.7488px 388.395px 0"
    },
    id: "el0v8oob5wpmti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 381.09c.15 0 .15.7 0 1.5s-.36 1.41-.5 1.41-.14-.7 0-1.51.36-1.43.5-1.4z",
    style: {
      fill: "#455a64",
      transformOrigin: "90.7538px 382.545px 0"
    },
    id: "elb2j9768okzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 375.24c.14 0 .14.7 0 1.51s-.37 1.44-.51 1.41-.14-.7 0-1.5.39-1.44.51-1.42z",
    style: {
      fill: "#455a64",
      transformOrigin: "91.745px 376.7px 0"
    },
    id: "elcpu6wy5wuhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 369.4c.14 0 .14.69 0 1.5s-.37 1.44-.51 1.42-.14-.7 0-1.51.41-1.44.51-1.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "92.745px 370.86px 0"
    },
    id: "elathwzmgqj6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.07 363.55c.14 0 .14.7 0 1.51s-.38 1.44-.52 1.41-.14-.7 0-1.5.38-1.44.52-1.42z",
    style: {
      fill: "#455a64",
      transformOrigin: "93.81px 365.01px 0"
    },
    id: "ellc15ot83otn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1 357.71c.14 0 .14.7 0 1.51s-.37 1.44-.52 1.41-.14-.7 0-1.51.42-1.44.52-1.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "94.8381px 359.17px 0"
    },
    id: "el1g38lvvt0wz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.14 351.87c.14 0 .14.7 0 1.5s-.38 1.44-.52 1.42-.14-.7 0-1.51.38-1.44.52-1.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "95.88px 353.33px 0"
    },
    id: "elfxm9hmt8xg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.19 346c.14 0 .14.7 0 1.5s-.38 1.44-.52 1.42-.14-.7 0-1.51.38-1.41.52-1.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "96.93px 347.46px 0"
    },
    id: "el6vkqhqzze83",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.25 340.19c.14 0 .14.7 0 1.5s-.38 1.44-.52 1.42-.14-.7 0-1.51.38-1.44.52-1.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "97.99px 341.65px 0"
    },
    id: "elt9jz4msm469",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.31 334.35c.15 0 .14.7 0 1.51s-.38 1.44-.52 1.41-.14-.7 0-1.51.38-1.43.52-1.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "99.0519px 335.81px 0"
    },
    id: "elqcyicif4r5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.39 328.52c.14 0 .14.7 0 1.5s-.39 1.44-.53 1.41-.13-.7 0-1.5.39-1.44.53-1.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "100.127px 329.975px 0"
    },
    id: "el0gtzdpyxu5a4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.48 322.68c.14 0 .13.7 0 1.51s-.39 1.44-.53 1.41-.13-.7 0-1.51.38-1.43.53-1.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "101.215px 324.14px 0"
    },
    id: "el63zlclliiii",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.57 316.85c.14 0 .13.7 0 1.51s-.39 1.43-.53 1.41-.13-.7 0-1.51.39-1.43.53-1.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "102.305px 318.31px 0"
    },
    id: "ela961my7p9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.68 311c.14 0 .13.7 0 1.51s-.4 1.43-.54 1.41-.13-.7 0-1.51.4-1.41.54-1.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "103.41px 312.46px 0"
    },
    id: "el2cwqpa5xwjx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.8 305.2c.14 0 .13.7 0 1.5s-.39 1.44-.53 1.41-.13-.7 0-1.51.39-1.43.53-1.4z",
    style: {
      fill: "#455a64",
      transformOrigin: "104.535px 306.655px 0"
    },
    id: "elub1eo4nw83d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.93 299.37c.14 0 .13.7 0 1.51s-.4 1.43-.54 1.4-.13-.7 0-1.5.4-1.44.54-1.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "105.66px 300.825px 0"
    },
    id: "elpodtu7bkdqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.07 293.55c.14 0 .13.7 0 1.5s-.4 1.44-.54 1.41-.13-.7 0-1.51.4-1.43.54-1.4z",
    style: {
      fill: "#455a64",
      transformOrigin: "106.8px 295.005px 0"
    },
    id: "elgnygrrlpw78",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.23 287.73c.14 0 .13.7 0 1.51s-.41 1.43-.55 1.4-.13-.7 0-1.51.41-1.43.55-1.4z",
    style: {
      fill: "#455a64",
      transformOrigin: "107.955px 289.185px 0"
    },
    id: "elfchkp54waho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4 281.91c.15 0 .13.71 0 1.51s-.41 1.43-.55 1.4-.13-.7 0-1.5.41-1.44.55-1.41z",
    style: {
      fill: "#455a64",
      transformOrigin: "109.127px 283.365px 0"
    },
    id: "elztbnxk7nrhg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.59 276.1c.14 0 .13.7 0 1.5s-.45 1.4-.59 1.4-.12-.71 0-1.51.45-1.42.59-1.39z",
    style: {
      fill: "#455a64",
      transformOrigin: "110.297px 277.55px 0"
    },
    id: "el0i5ddq6tog6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.5 271.72c.14 0 .19.38.1.78s-.26.71-.4.68-.19-.38-.11-.78.27-.71.41-.68z",
    style: {
      fill: "#455a64",
      transformOrigin: "111.349px 272.45px 0"
    },
    id: "elje0t7ka66e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.51 445.41c.14 0 .24.35.22.76s-.16.74-.3.74-.24-.35-.22-.77.15-.74.3-.73z",
    style: {
      fill: "#455a64",
      transformOrigin: "129.47px 446.16px 0"
    },
    id: "elrdh8d4cgeza",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.75 439.46c.15 0 .24.67.21 1.5s-.18 1.48-.32 1.47-.24-.67-.2-1.49.17-1.49.31-1.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "129.698px 440.945px 0"
    },
    id: "elofzpaw7k0q9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.94 433.5c.14 0 .24.68.21 1.5s-.16 1.48-.3 1.48-.24-.67-.22-1.5.16-1.48.31-1.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "129.891px 434.99px 0"
    },
    id: "elzjs9pypzd2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.09 427.55c.14 0 .24.67.22 1.49s-.15 1.49-.3 1.49-.24-.68-.22-1.5.15-1.48.3-1.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "130.05px 429.04px 0"
    },
    id: "el9rlqdmdedj5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.23 421.59c.14 0 .24.68.22 1.5s-.15 1.49-.29 1.48-.25-.67-.23-1.49.15-1.49.3-1.49z",
    style: {
      fill: "#455a64",
      transformOrigin: "130.19px 423.08px 0"
    },
    id: "elnel1utvfli9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.38 415.63c.15 0 .25.68.22 1.5s-.15 1.49-.3 1.48-.24-.67-.22-1.49.16-1.49.3-1.49z",
    style: {
      fill: "#455a64",
      transformOrigin: "130.341px 417.12px 0"
    },
    id: "el186oi6ikp2k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 409.68c.14 0 .24.67.21 1.5s-.17 1.48-.32 1.47-.23-.67-.2-1.49.17-1.49.31-1.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "130.53px 411.165px 0"
    },
    id: "el9s1phybezvf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.83 403.73c.14 0 .23.67.2 1.49s-.18 1.49-.32 1.48-.24-.68-.2-1.5.18-1.48.32-1.47z",
    style: {
      fill: "#455a64",
      transformOrigin: "130.768px 405.215px 0"
    },
    id: "el2wsl1kswh7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.06 397.77c.15 0 .24.68.21 1.5s-.18 1.48-.32 1.48-.24-.68-.2-1.5.17-1.48.31-1.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.008px 399.26px 0"
    },
    id: "elb01p85yfe1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.27 391.82c.14 0 .24.67.21 1.5s-.17 1.48-.31 1.48-.24-.68-.21-1.5.17-1.49.31-1.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.22px 393.31px 0"
    },
    id: "elj2izpd07388",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.45 385.86c.15 0 .24.67.22 1.5s-.16 1.48-.31 1.48-.24-.68-.21-1.5.16-1.48.3-1.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.409px 387.35px 0"
    },
    id: "elss25nah8p6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.61 379.91c.14 0 .24.67.22 1.49s-.15 1.49-.3 1.48-.24-.67-.22-1.49.15-1.49.3-1.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.57px 381.395px 0"
    },
    id: "el7i1opqbnr9m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.74 374c.14 0 .24.67.23 1.49s-.15 1.49-.29 1.49-.25-.67-.23-1.5.14-1.48.29-1.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.709px 375.49px 0"
    },
    id: "elp2w9j2bb7ud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.84 368c.14 0 .25.68.23 1.5s-.14 1.48-.28 1.48-.25-.67-.24-1.49.14-1.49.29-1.49z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.811px 369.49px 0"
    },
    id: "elmn32f1msmri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.91 362c.14 0 .25.67.24 1.49s-.15 1.51-.27 1.51-.26-.67-.25-1.5.13-1.5.28-1.5z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.89px 363.5px 0"
    },
    id: "elzjij7sco36l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 356.08c.14 0 .26.67.25 1.49s-.12 1.49-.27 1.49-.25-.67-.25-1.49.08-1.49.27-1.49z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.99px 357.57px 0"
    },
    id: "elfm1fucspxpn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 350.13c.15 0 .26.66.26 1.48s-.12 1.49-.26 1.49-.26-.66-.26-1.49.08-1.48.26-1.48z",
    style: {
      fill: "#455a64",
      transformOrigin: "132px 351.615px 0"
    },
    id: "elzfl6nz62w7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 344.17c.14 0 .26.66.26 1.49s-.11 1.49-.25 1.49-.26-.67-.27-1.49.06-1.49.26-1.49z",
    style: {
      fill: "#455a64",
      transformOrigin: "132px 345.66px 0"
    },
    id: "el2mg3vsxzdqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.9 338.21c.14 0 .27.67.27 1.49s-.1 1.49-.24 1.49-.27-.66-.28-1.49.11-1.49.25-1.49z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.91px 339.7px 0"
    },
    id: "ell0eu1ecq2ot",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.82 332.26c.15 0 .27.66.28 1.48s-.09 1.49-.23 1.49-.27-.66-.29-1.48.1-1.49.24-1.49z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.839px 333.745px 0"
    },
    id: "elml565yzcmn9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.72 326.3c.14 0 .27.66.29 1.49s-.09 1.49-.24 1.49-.27-.66-.28-1.48.08-1.49.23-1.5z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.751px 327.79px 0"
    },
    id: "eloydnn89gbl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.58 320.34c.15 0 .28.66.3 1.49s-.08 1.49-.22 1.49-.28-.66-.3-1.48.08-1.49.22-1.5z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.62px 321.83px 0"
    },
    id: "elux2d0ids8pl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37 314.38c.15 0 .29.66.32 1.48s-.06 1.5-.2 1.5-.29-.65-.32-1.48.06-1.49.2-1.5z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.43px 315.87px 0"
    },
    id: "elgmjp32wp1bg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 308.43c.14 0 .3.65.35 1.47s0 1.5-.16 1.51-.3-.65-.36-1.47.05-1.49.17-1.51z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.091px 309.92px 0"
    },
    id: "elnu14gr0siss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.48 302.5c.14 0 .33.64.41 1.46s0 1.49-.11 1.51-.32-.64-.41-1.46-.03-1.49.11-1.51z",
    style: {
      fill: "#455a64",
      transformOrigin: "130.625px 303.985px 0"
    },
    id: "ellkws2dyy14c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.9 298.07c.15 0 .31.3.37.71s0 .76-.15.78-.31-.3-.37-.71.01-.75.15-.78z",
    style: {
      fill: "#455a64",
      transformOrigin: "130.011px 298.815px 0"
    },
    id: "elq88sposjqao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.8 269.92a4.22 4.22 0 0 1 0 1.11c0 .7-.05 1.73-.11 3-.11 2.53-.29 6-.53 9.88-.13 1.92-.25 3.76-.36 5.44a15.82 15.82 0 0 1-.65 4.45 3.76 3.76 0 0 1-2.08 2.2 2.11 2.11 0 0 1-.82.16c-.19 0-.29 0-.29-.05a4.77 4.77 0 0 0 1-.29 3.68 3.68 0 0 0 1.81-2.15 16.39 16.39 0 0 0 .52-4.35c.1-1.69.21-3.52.32-5.44.24-3.86.48-7.35.69-9.88.1-1.26.19-2.28.26-3a5.39 5.39 0 0 1 .24-1.08z",
    style: {
      fill: "#455a64",
      transformOrigin: "131.398px 283.04px 0"
    },
    id: "elj5qy6oxxwej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.05 272.29c0-.06.45 0 .61.61a1.12 1.12 0 0 1-.22 1 1.09 1.09 0 0 1-1.24.25 1.05 1.05 0 0 1-.18-1.92c.53-.31.9-.05.86 0s-.34 0-.65.31a.8.8 0 0 0-.27.58.64.64 0 0 0 .43.56.66.66 0 0 0 .7-.1.83.83 0 0 0 .21-.61c-.03-.43-.3-.61-.25-.68z",
    style: {
      fill: "#455a64",
      transformOrigin: "130.586px 273.163px 0"
    },
    id: "ele69kqgjr175",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.81 276.53c0-.08.87.29 2.29.49a9.82 9.82 0 0 0 9.63-4.31c.8-1.19 1.07-2.06 1.16-2a5.18 5.18 0 0 1-.85 2.23 9.46 9.46 0 0 1-10 4.47 5.24 5.24 0 0 1-2.23-.88z",
    style: {
      fill: "#455a64",
      transformOrigin: "112.35px 274.15px 0"
    },
    id: "elk67yeuxpdtb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.42 269.92c.08 0 .1.74.45 1.84a8 8 0 0 0 6.39 5.6c1.14.2 1.87.12 1.88.21a3.84 3.84 0 0 1-1.93.16 7.63 7.63 0 0 1-6.7-5.87 3.67 3.67 0 0 1-.09-1.94z",
    style: {
      fill: "#455a64",
      transformOrigin: "154.735px 273.853px 0"
    },
    id: "elzr23n6voxcd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.47 274-59.12-4.09 2.05-28.24v-15.78l-5.74 8.87-17.81-15.5 19.17-25a30.12 30.12 0 0 1 11.66-7.55 24.29 24.29 0 0 1 7.31-1.4 29.32 29.32 0 0 0 17.66 0 86.69 86.69 0 0 1 16.05 3l22.38 6-7.37 27.49-13.52-4.55s7.42 51.05 7.28 56.75z",
    style: {
      fill: "#faa64b",
      transformOrigin: "131.965px 229.655px 0"
    },
    id: "el21s12ptmprn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.86 226.81a29.1 29.1 0 0 1 4.15-6.5 15 15 0 0 1-1.85 3.39 14.69 14.69 0 0 1-2.3 3.11z",
    style: {
      fill: "#263238",
      transformOrigin: "109.935px 223.56px 0"
    },
    id: "elczat4qae0hu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elehi5iuhttec"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "141.27px 194.61px 0"
    },
    className: "animable",
    id: "elp1doegnotuh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.27 194.61c0 .14-16.58.26-37 .26s-37-.12-37-.26 16.57-.26 37-.26 37 .12 37 .26z",
    style: {
      fill: "#fff",
      transformOrigin: "141.27px 194.61px 0"
    },
    id: "elufiesaqujvs",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elk6xb97oteq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "134.745px 207.37px 0"
    },
    className: "animable",
    id: "el56gm3qlv7ti"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.69 207.37c0 .15-17.88.26-39.94.26s-39.95-.11-39.95-.26 17.88-.26 40-.26 39.89.12 39.89.26z",
    style: {
      fill: "#fff",
      transformOrigin: "134.745px 207.37px 0"
    },
    id: "eld4vkmm0fva",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eld0udmkvbi87"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "123.395px 221.41px 0"
    },
    className: "animable",
    id: "elix4bn8e4vdc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.14 221.41c0 .14-16 .26-35.74.26s-35.75-.12-35.75-.26 16-.26 35.75-.26 35.74.12 35.74.26z",
    style: {
      fill: "#fff",
      transformOrigin: "123.395px 221.41px 0"
    },
    id: "el5ws55q1abpr",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el9q1od9e9own"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "134.71px 236.69px 0"
    },
    className: "animable",
    id: "elnhixx9ek7ih"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161 236.69c0 .14-11.77.26-26.29.26s-26.29-.12-26.29-.26 11.76-.26 26.29-.26 26.29.11 26.29.26z",
    style: {
      fill: "#fff",
      transformOrigin: "134.71px 236.69px 0"
    },
    id: "el0f58t899srrl",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el7uqci51ggqe"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "135.55px 252.54px 0"
    },
    className: "animable",
    id: "elyfsjip5r62r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.55 252.54c0 .14-12.08.26-27 .26s-27-.12-27-.26 12.08-.26 27-.26 27 .12 27 .26z",
    style: {
      fill: "#fff",
      transformOrigin: "135.55px 252.54px 0"
    },
    id: "elbepyjvkqgr",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el8p92uufxs7q"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "135.785px 267.08px 0"
    },
    className: "animable",
    id: "ela2zec1aiw2j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165 267.08c0 .14-13.08.26-29.21.26s-29.22-.12-29.22-.26 13.08-.26 29.22-.26 29.21.11 29.21.26z",
    style: {
      fill: "#fff",
      transformOrigin: "135.785px 267.08px 0"
    },
    id: "elgsrt453bq7h",
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "red",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountHead);
export default __webpack_public_path__ + "static/media/accountHead.41b98b5c1df1c16223a57a09f69a8c7e.svg";
export { ForwardRef as ReactComponent };